"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Signup Form Stages
 * Handles the two-stage popup signup flow: option selection → registration form.
 * The selected option value is written into the hidden customer[note] field.
 */
function signupFormStages() {
    var stages = document.querySelectorAll('.js-signup-stage[data-stage="question"]');
    if (!stages.length)
        return;
    stages.forEach(function (questionStage) {
        var formId = questionStage.dataset.formId;
        if (!formId)
            return;
        var formStage = document.querySelector(".js-signup-stage[data-stage=\"form\"][data-form-id=\"" + formId + "\"]");
        var noteInput = formStage === null || formStage === void 0 ? void 0 : formStage.querySelector('input[name="customer[note]"]');
        if (!formStage || !noteInput)
            return;
        var buttons = questionStage.querySelectorAll('.js-signup-option[data-value]');
        buttons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var _a;
                noteInput.value = (_a = btn.dataset.value) !== null && _a !== void 0 ? _a : '';
                questionStage.style.display = 'none';
                formStage.style.display = '';
            });
        });
    });
}
exports.default = signupFormStages;
